"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AminoPrefix = void 0;
var AminoPrefix;
exports.AminoPrefix = AminoPrefix;

(function (AminoPrefix) {
  AminoPrefix["MsgSend"] = "2A2C87FA";
  AminoPrefix["NewOrderMsg"] = "CE6DC043";
  AminoPrefix["CancelOrderMsg"] = "166E681B";
  AminoPrefix["IssueMsg"] = "17EFAB80";
  AminoPrefix["BurnMsg"] = "7ED2D2A0";
  AminoPrefix["FreezeMsg"] = "E774B32D";
  AminoPrefix["UnfreezeMsg"] = "6515FF0D";
  AminoPrefix["MintMsg"] = "467E0829";
  AminoPrefix["ListMsg"] = "B41DE13F";
  AminoPrefix["StdTx"] = "F0625DEE";
  AminoPrefix["PubKeySecp256k1"] = "EB5AE987";
  AminoPrefix["SignatureSecp256k1"] = "7FC4A495";
  AminoPrefix["MsgSubmitProposal"] = "B42D614E";
  AminoPrefix["MsgDeposit"] = "A18A56E5";
  AminoPrefix["MsgVote"] = "A1CADD36";
  AminoPrefix["TimeLockMsg"] = "07921531";
  AminoPrefix["TimeUnlockMsg"] = "C4050C6C";
  AminoPrefix["TimeRelockMsg"] = "504711DA";
  AminoPrefix["HTLTMsg"] = "B33F9A24";
  AminoPrefix["DepositHTLTMsg"] = "63986496";
  AminoPrefix["ClaimHTLTMsg"] = "C1665300";
  AminoPrefix["RefundHTLTMsg"] = "3454A27C";
  AminoPrefix["SetAccountFlagsMsg"] = "BEA6E301";
  AminoPrefix["BnbchainAccount"] = "4BDC4C27";
  AminoPrefix["BnbchainToken"] = "140364E6";
  AminoPrefix["MsgCreateValidator"] = "EB361D01";
  AminoPrefix["MsgRemoveValidator"] = "C1AFE85F";
  AminoPrefix["MsgCreateValidatorProposal"] = "DB6A19FD";
  AminoPrefix["MsgEditValidator"] = "C2E8BCCD";
  AminoPrefix["MsgDelegate"] = "921D2E4E";
  AminoPrefix["MsgBeginUnbonding"] = "A3823C9A";
  AminoPrefix["MsgBeginRedelegate"] = "267996D2";
  AminoPrefix["MsgCreateSideChainValidator"] = "D17201E5";
  AminoPrefix["MsgEditSideChainValidator"] = "264CC57B";
  AminoPrefix["MsgSideChainDelegate"] = "E3A07FD2";
  AminoPrefix["MsgSideChainRedelegate"] = "E3CED364";
  AminoPrefix["MsgSideChainUndelegate"] = "514F7E0E";
  AminoPrefix["Claim"] = "4E781C11";
  AminoPrefix["ClaimMsg"] = "175A0521";
  AminoPrefix["BindMsg"] = "B9AE640C";
  AminoPrefix["TransferOutMsg"] = "800819C0";
  AminoPrefix["IssueMiniMsg"] = "A3F16C41";
  AminoPrefix["IssueTinyMsg"] = "ED2832D4";
  AminoPrefix["SetURIMsg"] = "7B1D34E7";
  AminoPrefix["ListMiniMsg"] = "4C264019";
  AminoPrefix["MiniToken"] = "E0051C20";
})(AminoPrefix || (exports.AminoPrefix = AminoPrefix = {}));